import { sharedStyles } from "@/styles/shared";
import Box from "@mui/material/Box/Box";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography/Typography";
import { useAuth } from "@/context/AuthProvider/useAuth";
import { useNavigate } from "react-router-dom";
import { PrimaryButton } from "../buttons/PrimaryButton";
import { SecondaryButton } from "../buttons/SecondaryButton";
import IconButton from "@mui/material/IconButton/IconButton";
import { handleLogout } from "@/utils/miscelaneous";
import GenericModal from "../GenericModal";
import { Dispatch, SetStateAction } from "react";

interface QuitConfirmationModalProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const QuitConfirmationModal = (props: QuitConfirmationModalProps) => {
  const { open, setOpen } = props;

  const auth = useAuth();
  const navigate = useNavigate();

  const handleCloseModal = () => setOpen(false);

  const QuitModal = (
    <Box sx={{ ...sharedStyles.verticalContent, gap: 3 }}>
      <IconButton
        onClick={handleCloseModal}
        sx={{ position: "absolute", right: 0, top: 0 }}
      >
        <CloseIcon />
      </IconButton>

      <Typography variant="h6">Tem certeza que deseja sair?</Typography>

      <Box sx={{ ...sharedStyles.verticalContent }}>
        <PrimaryButton
          label="Sair"
          styles={sharedStyles.secondaryColor}
          onClickAction={() => handleLogout(auth, navigate)}
        />
        <SecondaryButton label="Cancelar" onClickAction={handleCloseModal} />
      </Box>
    </Box>
  );

  return (
    <GenericModal open={open} onClose={handleCloseModal} content={QuitModal} />
  );
};

export default QuitConfirmationModal;
